/* ---- SCR-005: Login page ----
 * Android: ネイティブ Google Sign-In → ID Token → サーバ認証
 * ブラウザ: Google Identity Services (GIS) リダイレクト方式
 */

import { sdkBridge } from '../bridge/sdk-bridge';
import { ICONS } from '../icons';
import { api } from '../services/api.service';
import { authService } from '../services/auth.service';

export function renderLoginPage(onLoginSuccess: () => void): HTMLElement {
  const screen = document.createElement('div');
  screen.className = 'login-screen';

  screen.innerHTML = `
    <div class="login-logo">
      <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
        <circle cx="32" cy="32" r="30" fill="#EFF6FF" stroke="#0066FF" stroke-width="2"/>
        <path d="M32 14C25.4 14 20 19.4 20 26c0 9 12 22 12 22s12-13 12-22c0-6.6-5.4-12-12-12z" fill="#0066FF" opacity="0.15"/>
        <path d="M32 14C25.4 14 20 19.4 20 26c0 9 12 22 12 22s12-13 12-22c0-6.6-5.4-12-12-12z" fill="none" stroke="#0066FF" stroke-width="2"/>
        <circle cx="32" cy="26" r="4" fill="#0066FF"/>
      </svg>
    </div>
    <div class="login-title">Location Proof</div>
    <div class="login-sub">位置証明・認証アプリ</div>
    <button class="login-btn google" id="login-google">
      ${ICONS.google}
      Googleでログイン
    </button>
    <div id="login-status" style="color:var(--text-muted,#888);font-size:12px;text-align:center;margin:8px 0;display:none;"></div>
    <div id="login-error" style="color:#ef4444;font-size:13px;text-align:center;margin:8px 0;display:none;"></div>
  `;

  const errorEl = screen.querySelector('#login-error') as HTMLElement;
  const statusEl = screen.querySelector('#login-status') as HTMLElement;
  const googleBtn = screen.querySelector('#login-google') as HTMLButtonElement;

  // ネイティブからの Google Sign-In 結果コールバックを登録
  sdkBridge.setCallbacks({
    onGoogleSignIn: async (data: { id_token: string; email: string; name: string }) => {
      statusEl.textContent = '認証中...';
      statusEl.style.display = 'block';
      errorEl.style.display = 'none';

      try {
        await authService.loginWithGoogle(data.id_token);

        // ログイン成功後、SDK の UUID をサーバに登録
        const uuid = sdkBridge.getUuid();
        if (uuid) {
          try {
            await api.post('/users/me/device', { device_uuid: uuid, platform: 'android' });
            const user = authService.getUser();
            if (user) authService.setUser({ ...user, device_uuid: uuid });
          } catch {
            /* デバイス登録失敗は無視 */
          }
        }

        onLoginSuccess();
      } catch (err) {
        errorEl.textContent = `ログインに失敗しました: ${(err as Error).message}`;
        errorEl.style.display = 'block';
        statusEl.style.display = 'none';
      }
    },
    onGoogleSignInError: (data: { code: string; message: string }) => {
      errorEl.textContent = data.message;
      errorEl.style.display = 'block';
      statusEl.style.display = 'none';
    },
  });

  // Google ログインボタン
  googleBtn.addEventListener('click', () => {
    errorEl.style.display = 'none';

    const platform = sdkBridge.getPlatform();
    if (platform === 'android' || platform === 'ios') {
      // Android: ネイティブ GoogleSignIn API
      // iOS: ASWebAuthenticationSession で OAuth 2.0 implicit flow を起動
      statusEl.textContent = 'Google認証画面を起動中...';
      statusEl.style.display = 'block';
      sdkBridge.signInWithGoogle();
    } else {
      // ブラウザ: 未サポート（開発用）
      errorEl.textContent =
        'この環境では Google ログインは利用できません。アプリからアクセスしてください。';
      errorEl.style.display = 'block';
    }
  });

  return screen;
}
